import { Entity } from '@adornis/baseql/decorators.js';
import { FormOfFinancing } from './FormOfFinancing.js';

/**
 * @entity FormOfFinancingStiftungsgeld
 */
@Entity()
export class FormOfFinancingStiftungsgeld extends FormOfFinancing {
  public static override _class = 'FormOfFinancingStiftungsgeld';
}
